import React from 'react';

/** Site footer removed; kept as a no-op so pages can stay consistent without UI. */
export default function Footer() {
  return null;
}
